import { atom } from "recoil";

// 確認画面設定
export const confirmState = atom({
  key: "confirmState",
  default: false,
});